import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-12 financial-calendar" }
const _hoisted_3 = { class: "card shadow-sm" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "card shadow-sm" }
const _hoisted_12 = {
  key: 0,
  class: "px-2 py-4"
}
const _hoisted_13 = { class: "table-responsive" }
const _hoisted_14 = { class: "table table-bordered table-financial" }
const _hoisted_15 = { class: "fw-bold" }
const _hoisted_16 = { class: "fw-bold" }
const _hoisted_17 = { class: "fw-bold" }
const _hoisted_18 = { class: "fw-bold" }
const _hoisted_19 = { class: "fw-bold" }
const _hoisted_20 = { class: "fw-bold" }
const _hoisted_21 = { class: "fw-bold" }
const _hoisted_22 = { class: "fw-bold" }
const _hoisted_23 = { class: "fw-bold" }
const _hoisted_24 = { class: "fw-bold" }
const _hoisted_25 = { class: "fw-bold" }
const _hoisted_26 = { class: "fw-bold" }
const _hoisted_27 = { class: "fw-bold" }
const _hoisted_28 = { class: "fw-bold" }
const _hoisted_29 = { class: "fw-bold" }
const _hoisted_30 = { class: "fw-bold" }
const _hoisted_31 = { class: "fw-bold" }
const _hoisted_32 = { class: "fw-bold" }
const _hoisted_33 = { class: "fw-bold" }
const _hoisted_34 = { class: "fw-bold" }
const _hoisted_35 = { class: "fw-bold" }
const _hoisted_36 = { class: "fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_financial_row = _resolveComponent("financial-row")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("select", {
                  class: "border-0 text-secondary me-2",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query_platform) = $event))
                }, _cache[8] || (_cache[8] = [
                  _createElementVNode("option", { value: null }, "Select Platform", -1),
                  _createElementVNode("option", { value: 0 }, "SP-ED", -1),
                  _createElementVNode("option", { value: 1 }, "Simclusive", -1)
                ]), 512), [
                  [_vModelSelect, _ctx.query_platform]
                ]),
                _withDirectives(_createElementVNode("select", {
                  class: "border-0 text-secondary me-2",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query_month) = $event))
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['01','02','03','04','05','06','07','08','09','10','11','12'], (ind) => {
                    return _createElementVNode("option", {
                      key: ind,
                      value: ind
                    }, _toDisplayString(_ctx.moment('2021-' + ind + '-01 00:00:00').format('MMMM')), 9, _hoisted_5)
                  }), 64))
                ], 512), [
                  [_vModelSelect, _ctx.query_month]
                ]),
                _withDirectives(_createElementVNode("select", {
                  class: "border-0 text-secondary me-2",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.query_year) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: year,
                      value: year
                    }, _toDisplayString(year), 9, _hoisted_6))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.query_year]
                ]),
                _withDirectives(_createElementVNode("select", {
                  class: "border-0 text-secondary me-2",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.query_scenario) = $event))
                }, [
                  _cache[9] || (_cache[9] = _createElementVNode("option", { value: null }, "Select Scenario", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenarios, (scenario) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: scenario.id,
                      value: scenario.id
                    }, _toDisplayString(scenario.patient_name), 9, _hoisted_7))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.query_scenario]
                ]),
                _withDirectives(_createElementVNode("select", {
                  class: "border-0 text-secondary me-2",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.query_partner) = $event))
                }, [
                  _cache[10] || (_cache[10] = _createElementVNode("option", { value: null }, "Select Partner", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: partner.id,
                      value: partner.id
                    }, _toDisplayString(partner.short_name), 9, _hoisted_8))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.query_partner]
                ]),
                _withDirectives(_createElementVNode("select", {
                  class: "border-0 text-secondary me-2",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.query_job_number) = $event))
                }, [
                  _cache[11] || (_cache[11] = _createElementVNode("option", { value: null }, "Select Job Number", -1)),
                  _cache[12] || (_cache[12] = _createElementVNode("option", { value: -1 }, "Not associated to Job Number", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.job_numbers, (job_number, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: job_number
                    }, _toDisplayString(job_number), 9, _hoisted_9))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.query_job_number]
                ]),
                _createElementVNode("button", {
                  class: "btn btn-lg btn-primary",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getFinancialReport()))
                }, "Generate"),
                _createElementVNode("button", {
                  class: "btn btn-lg btn-primary ms-4",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.exportFinancialReport()))
                }, "Export")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_ctx.report_job_numbers.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Job Numbers in report: " + _toDisplayString(_ctx.report_job_numbers), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("table", _hoisted_14, [
                  _cache[26] || (_cache[26] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th"),
                      _createElementVNode("th", null, "Name"),
                      _createElementVNode("th", null, "Email"),
                      _createElementVNode("th", null, "SP Hours"),
                      _createElementVNode("th", null, "No Show Hours"),
                      _createElementVNode("th", null, "Learner Tech Issue Hours"),
                      _createElementVNode("th", null, "Late Cancellation Hours"),
                      _createElementVNode("th", null, "Early Cancellation Hours"),
                      _createElementVNode("th", null, "Observer Hours"),
                      _createElementVNode("th", null, "Trainer Hours"),
                      _createElementVNode("th", null, "Training Hours"),
                      _createElementVNode("th", null, "Interview Hours"),
                      _createElementVNode("th", null, "Author Hours"),
                      _createElementVNode("th", null, "Total Hours"),
                      _createElementVNode("th", null, "SP Rate"),
                      _createElementVNode("th", null, "No Show Rate"),
                      _createElementVNode("th", null, "Learner Tech Issue Rate"),
                      _createElementVNode("th", null, "Late Cancellation Rate"),
                      _createElementVNode("th", null, "Early Cancellation Rate"),
                      _createElementVNode("th", null, "Observer Rate"),
                      _createElementVNode("th", null, "Trainer Rate"),
                      _createElementVNode("th", null, "Training Rate"),
                      _createElementVNode("th", null, "Interview Rate"),
                      _createElementVNode("th", null, "Author Rate"),
                      _createElementVNode("th", null, "SP Total"),
                      _createElementVNode("th", null, "No Show Total"),
                      _createElementVNode("th", null, "Learner Tech Issue Total"),
                      _createElementVNode("th", null, "Late Cancellation Total"),
                      _createElementVNode("th", null, "Early Cancellation Total"),
                      _createElementVNode("th", null, "Observer Total"),
                      _createElementVNode("th", null, "Trainer Total"),
                      _createElementVNode("th", null, "Training Total"),
                      _createElementVNode("th", null, "Interview Total"),
                      _createElementVNode("th", null, "Author Total"),
                      _createElementVNode("th", null, "Total")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user_records, (user, ind) => {
                      return (_openBlock(), _createBlock(_component_financial_row, {
                        key: user.user_id,
                        user: user,
                        ind: ind
                      }, null, 8, ["user", "ind"]))
                    }), 128))
                  ]),
                  _createElementVNode("tfoot", null, [
                    _createElementVNode("tr", null, [
                      _cache[13] || (_cache[13] = _createElementVNode("th", null, null, -1)),
                      _cache[14] || (_cache[14] = _createElementVNode("th", { class: "fw-bold" }, "Grand Total", -1)),
                      _cache[15] || (_cache[15] = _createElementVNode("td", { class: "fw-bold" }, "-", -1)),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.grand_hours_sp), 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.grand_hours_no_show), 1),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.grand_hours_learner_tech), 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.grand_hours_late_canc), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.grand_hours_early_canc), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.grand_hours_scorecard), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.grand_hours_trainer), 1),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.grand_hours_training), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.grand_hours_interviews), 1),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.grand_hours_authoring), 1),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.grand_hours), 1),
                      _cache[16] || (_cache[16] = _createElementVNode("td", { class: "fw-bold" }, "-", -1)),
                      _cache[17] || (_cache[17] = _createElementVNode("td", { class: "fw-bold" }, "-", -1)),
                      _cache[18] || (_cache[18] = _createElementVNode("td", { class: "fw-bold" }, "-", -1)),
                      _cache[19] || (_cache[19] = _createElementVNode("td", { class: "fw-bold" }, "-", -1)),
                      _cache[20] || (_cache[20] = _createElementVNode("td", { class: "fw-bold" }, "-", -1)),
                      _cache[21] || (_cache[21] = _createElementVNode("td", { class: "fw-bold" }, "-", -1)),
                      _cache[22] || (_cache[22] = _createElementVNode("td", { class: "fw-bold" }, "-", -1)),
                      _cache[23] || (_cache[23] = _createElementVNode("td", { class: "fw-bold" }, "-", -1)),
                      _cache[24] || (_cache[24] = _createElementVNode("td", { class: "fw-bold" }, "-", -1)),
                      _cache[25] || (_cache[25] = _createElementVNode("td", { class: "fw-bold" }, "-", -1)),
                      _createElementVNode("td", _hoisted_26, "$" + _toDisplayString(_ctx.grand_total_sp), 1),
                      _createElementVNode("td", _hoisted_27, "$" + _toDisplayString(_ctx.grand_total_no_show), 1),
                      _createElementVNode("td", _hoisted_28, "$" + _toDisplayString(_ctx.grand_total_learner_tech), 1),
                      _createElementVNode("td", _hoisted_29, "$" + _toDisplayString(_ctx.grand_total_late_canc), 1),
                      _createElementVNode("td", _hoisted_30, "$" + _toDisplayString(_ctx.grand_total_early_canc), 1),
                      _createElementVNode("td", _hoisted_31, "$" + _toDisplayString(_ctx.grand_total_scorecard), 1),
                      _createElementVNode("td", _hoisted_32, "$" + _toDisplayString(_ctx.grand_total_trainer), 1),
                      _createElementVNode("td", _hoisted_33, "$" + _toDisplayString(_ctx.grand_total_training), 1),
                      _createElementVNode("td", _hoisted_34, "$" + _toDisplayString(_ctx.grand_total_interviews), 1),
                      _createElementVNode("td", _hoisted_35, "$" + _toDisplayString(_ctx.grand_total_authoring), 1),
                      _createElementVNode("td", _hoisted_36, "$" + _toDisplayString(_ctx.grand_total), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ]))
}